// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4015":"d860d6f6","8220":"d860d6f6"}[chunkId] + ".chunk.css";
};